import type { Permanence } from '../types/catalog';
import type { ShippingOption } from '../types/cart';

// Date de référence de la boutique (saison en cours)
export const TODAY = new Date(2026, 9, 10, 10, 0, 0);

export const store = {
  name: 'L’Éphémère Perpétuel',
  address: '14 rue des Tanneurs',
  city: '33000 Bordeaux',
  phone: '05 56 00 00 00',
  email: 'bonjour@ephemere-perpetuel.fr',
  hours: [
    { days: 'Mardi – Samedi', time: '10h30 – 19h00' },
    { days: 'Dimanche & lundi', time: 'Fermé' },
  ],
};

export const season = {
  name: 'Saison d’automne',
  start: '2026-09-01',
  end: '2026-12-31',
};

export const announcements = [
  'Livraison offerte dès 80 € d’achat',
  'Retrait gratuit en boutique sous 24 h',
  'Emballage cadeau offert, noué à la main par nos créateurs',
];

export const FREE_SHIPPING_THRESHOLD = 80;

export const shippingOptions: ShippingOption[] = [
  {
    id: 'pickup',
    label: 'Retrait en boutique',
    description: 'Prête sous 24 h, remise par le créateur de permanence',
    delay: 'Dès demain',
    price: 0,
    freeAboveThreshold: true,
  },
  {
    id: 'relay',
    label: 'Point relais',
    description: 'Mondial Relay, plus de 8 000 points en France',
    delay: '3 – 5 jours ouvrés',
    price: 3.9,
    freeAboveThreshold: true,
  },
  {
    id: 'home',
    label: 'Colissimo à domicile',
    description: 'Remise contre signature, suivi par e-mail',
    delay: '2 – 3 jours ouvrés',
    price: 5.9,
    freeAboveThreshold: true,
  },
];

export const promoCodes: Record<string, number> = {
  BIENVENUE10: 0.1,
};

export const timelineRange = {
  start: '2026-06-01',
  end: '2027-02-28',
};

export const permanences: Permanence[] = [
  { date: '2026-10-10', creatorIds: ['atelier-sillon', 'maison-ocre'] },
  { date: '2026-10-13', creatorIds: ['lin-et-lame', 'herbier-noir'] },
  { date: '2026-10-14', creatorIds: ['feutre-et-forme', 'savonnerie-des-pres'] },
  { date: '2026-10-15', creatorIds: ['terre-de-lune', 'cuir-sauvage'] },
  { date: '2026-10-16', creatorIds: ['argent-brut', 'rucher-du-vallon'] },
  { date: '2026-10-17', creatorIds: ['fil-indigo', 'bois-de-coeur', 'perle-de-rive'] },
];
